// Список всех изображений для предзагрузки
export const IMAGES_TO_PRELOAD = [
  // Buttons
  "/src/assets/img/button_main_glow.png",
  "/src/assets/img/button_main_glow_start.png",
  "/src/assets/img/award_button.png",
  "/src/assets/img/end_button.png",
  
  // Cards backgrounds
  "/src/assets/img/chaos_card_bg.png",
  "/src/assets/img/k8s_keeper_card_bg.png",
  "/src/assets/img/master_card_bg.png",
  "/src/assets/img/yaml_card_bg.png",
  "/src/assets/img/reward_bg.png",
  "/src/assets/img/share_panel_bg.png",
  
  // Avatars
  "/src/assets/img/chaos_monster_avatar.png",
  "/src/assets/img/k8s_avatar.png",
  "/src/assets/img/master_avatar.png",
  "/src/assets/img/yaml_avatar.png",
  "/src/assets/img/oracle_new_avatar.png",
  "/src/assets/img/hero_avatar.png",
  "/src/assets/img/masterbot_avatar_tip.png",
  "/src/assets/img/avatar_blue.png",
  "/src/assets/img/avatar_black.png",
  
  // Icons (locked states)
  "/src/assets/img/icon_guard.png",
  "/src/assets/img/icon_print.png",
  "/src/assets/img/icon_shield.png",
  "/src/assets/img/icon_storage.png",
  "/src/assets/img/icon_vision.png",
  
  // Icons (unlocked states)
  "/src/assets/img/guard_unlocked.png",
  "/src/assets/img/print_unlocked.png",
  "/src/assets/img/shield_unlocked.png",
  "/src/assets/img/storage_unlocked.png",
  "/src/assets/img/vision_unlocked.png",
  
  // Achievements
  "/src/assets/img/acheivements.png",
  "/src/assets/img/acheivements-1.png",
  "/src/assets/img/acheivements-2.png",
  "/src/assets/img/acheivements-3.png",
  "/src/assets/img/acheivements-4.png",
  
  // Other UI elements
  "/src/assets/img/award_gradient.png",
  "/src/assets/img/grid_pattern.svg",
  "/src/assets/img/error_message.png",
  "/src/assets/img/yc_qr.png",
] as const;

class ImagePreloader {
  private loadedImages = new Set<string>();
  private loadingPromises = new Map<string, Promise<HTMLImageElement>>();

  preloadImage(src: string): Promise<HTMLImageElement> {
    if (this.loadedImages.has(src)) {
      return Promise.resolve(new Image());
    }

    if (this.loadingPromises.has(src)) {
      return this.loadingPromises.get(src)!;
    }

    const promise = new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      
      img.onload = () => {
        this.loadedImages.add(src);
        this.loadingPromises.delete(src);
        resolve(img);
      };
      
      img.onerror = () => {
        this.loadingPromises.delete(src);
        reject(new Error(`Failed to load image: ${src}`));
      };
      
      img.src = src;
    });

    this.loadingPromises.set(src, promise);
    return promise;
  }

  async preloadAll(images: readonly string[] = IMAGES_TO_PRELOAD): Promise<void> {
    const promises = images.map(src => this.preloadImage(src).catch(err => {
      console.warn(`Failed to preload image ${src}:`, err);
      return null;
    }));

    await Promise.all(promises);
  }

  isLoaded(src: string): boolean {
    return this.loadedImages.has(src);
  }

  getLoadedCount(): number {
    return this.loadedImages.size;
  }

  getTotalCount(): number {
    return IMAGES_TO_PRELOAD.length;
  }

  getProgress(): number {
    return (this.getLoadedCount() / this.getTotalCount()) * 100;
  }
}

export const imagePreloader = new ImagePreloader();

// Функция для инициализации предзагрузки при старте приложения
export function initImagePreloader(): Promise<void> {
  return imagePreloader.preloadAll();
}